export const REACT_APP_API_URL = process.env.REACT_APP_API_URL ?? "";
export const REACT_APP_COGNITO_DOMAIN_URL = process.env.REACT_APP_COGNITO_DOMAIN_URL ?? "";
export const REACT_APP_COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION ?? "";
export const REACT_APP_COGNITO_USERPOOL_ID = process.env.REACT_APP_COGNITO_USERPOOL_ID ?? "";
export const REACT_APP_COGNITO_USERPOOL_CLIENT_ID = process.env.REACT_APP_COGNITO_USERPOOL_CLIENT_ID ?? "";
export const REACT_APP_WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL ?? "";
export const apiUrl = {
  ACCESS_TOKEN_API_URL: REACT_APP_COGNITO_DOMAIN_URL + 'oauth2/token',
  UPLOAD_AUDIO_FILE: "/api/audio",
  GET_P1_QUESTIONS: "/api/get_p1_questions",
  GET_EXTENDED_CONTENT: "/extendedContent",
  GET_PROBES: "/probes",
  GET_CONTENT_DATA: "/baseContent",
  GET_INT_SUITE_CONTENT: "/intSuiteContent",
  GET_SESSION_ID_URL: "/userSession/sessionId",
  INTENT_AUDIO_DETECTION: "intentDetectionAudio",
  FULL_RECORDING: "full-recording",
  SPEAKING_TEST_PROGRESSION_DATA: "/speakingTestProgression",
  HEALTH_CHECK: "/actuator/health",
  INTENT_HEALTH_CHECK: "/intent/health",
  VALIDATE_INSPERA_ACCESS_TOKEN_API_URL: "/auth/validate",
  DOWNLOAD_AUDIO_FILE: "api/audioDownload",
  TEST_RULES: "/testRules",
  PRECHECK_LOGS: "/api/uploadPreCheckDetails"
};

export const awsExports = {
    Auth: {
        region: REACT_APP_COGNITO_REGION,
        Cognito: {
            userPoolId: REACT_APP_COGNITO_USERPOOL_ID,
            userPoolClientId: REACT_APP_COGNITO_USERPOOL_CLIENT_ID,
        },
        oauth: {
            domain: REACT_APP_COGNITO_DOMAIN_URL,
            scope: ["phone", "email", "openid", "profile", "aws.cognito.signin.user.admin"],
            redirectSignIn: REACT_APP_API_URL,
            redirectSignOut: REACT_APP_API_URL,
            responseType: "code",
        },
    },
};

export const commonValues = {
    POST: "POST",
    SESSION_ID: "Jun2024",
};

export const loginTexts = {
    ENTER_TEXT: "Enter",
    PAGE_TITLE: "Signin with Email",
    INVALID_CREDENTIAL: "Invalid Credential",
    EMAIL_LABEL: "Email Id",
    USERNAME_LABEL: "Username",
    PASSWORD_LABEL: "Password",
    SIGNIN_BTN_LABEL: "Sign in",
    PASSWORD_REQUIRED: "NEW_PASSWORD_REQUIRED",
    FORGOT_PASSWORD: "Forgot Password",
    BACK: "Back to Login",
    SEND_CODE: "Send Code",
    CODE_SENT: "Code has been sent to your mail id",
    CODE: "Code",
    NEW_PASSWORD: "New Password",
    CONFIRM_PASSWORD: "Confirm Password",
    RESET_PASSWORD: "Reset Password",
    SUCCESS: "SUCCESS",
    SUCCESS_PASSWORD: "Password has been changed successfully",
    INVALID_CODE: "Entered invalid code",
    CODE_FAILED: "Sending code failed",
    LOGIN_SECTION_NAME: "Test Taker Login",
};

export const errorMessages = {
    EMPTY_EMAIL: "Please enter email id",
    INVALID_EMAIL: "Please enter valid email id",
    EMPTY_USERNAME: "Please enter username",
    EMPTY_PASSWORD: "Please enter password",
    EMPTY_CODE: "Please enter code received in the mail",
    EMPTY_NEW_PASSWORD: "Please enter new password",
    EMPTY_CONFIRM_PASSWORD: "Please enter confirm password",
    MISMATCH_PASSWORD: "New password and confirm password are not matching",
};

export const animationModes = {
    IDLE: "idle",
    LISTENING: "listening",
    ENCOURAGING: "encouraging",
    TALKING: "talking",
    TALKING_DURATION: 10,
    TIMER_VALUE: 60000,
};

export const audioPlayReasons = {
    PLAYING: "playing",
    NOT_PLAYING: "notPlaying",
    NO_RESPONSE: "No Response",
    NOT_MUCH_RESPONDED: "Short Response",
    MAX_DURATION_REACHED: "Max Duration Reached",
    QUESTION_COMPLETED: "Question Completed",
    NOT_STARTED: "Not Started",
    RECEIVED: "Received",
    IN_PROGRESS: "In Progress",
    CAN_RESTART: "Can Restart",
    MAX_DURATION_FOR_PART_REACHED: "Max Duration for part reached",
    AUDIO_STARTED: "Audio Started",
    AUDIO_ENDED: "Audio Ended",
    PROMPT_COMPLETED: "Prompt Completed",
};

export const timeProgressBar = {
    DURATION: 120, // 120 seconds
    YOUR_TIME_STARTS_NOW: "Your time starts now",
    ONE_MINUTE_LEFT: "1 minute left",
};

export const appThemeNames = {
    BLACK_ON_WHITE: "black_on_white",
    WHITE_ON_BLACK: "white_on_black",
    YELLOW_ON_BLACK: "yellow_on_black",
};

export const intentResponse = {
    REPEAT: "REPEAT",
    MOVE_ON: "MOVE-ON",
    STUCK: "STUCK",
};

export const contentType = {
    prompt: "PROMPT",
    probe: "PROBE",
    variant: "VARIANT",
} as const;

export const MAX_DURATION = 15000;

export const MIN_DURATION = 0;

export const RULE_TWO_SILENCE_DURATION = 3;

export const RULE_ONE_SILENCE_DURATION = 7;

export const RULE_FOUR_MAX_COUNTER = 1;

export const RULE_THREE_MIN_DURATION = 3;

export const RULE_TWO_PART_2_SILENCE_DURATION = 5;

export const INTENT_DETECTION_TIME = 3;

export const RULE_THREE_PART_2_MIN_DURATION = 5;

export const Parts = {
    PART_1: "part1",
    PART_2: "part2",
    PART_3: "part3",
};

export const PartsMaxDuration = {
    part1: 300,
    part2: 250,
    part3: 300,
};

export const additionalDurationForParts: any = {
    part1: 20,
    part2: 5,
    part3: 20,
};
export const cubeParams: any = {
    mainCube: {
        height: 380,
        width: 620,
    },
    sideCube: {
        height: 270,
        width: 270,
    },
};

export const fileKey = "precheck/10-MB-MP3.mp3";

export const audioEndReasons = {
    FULL_RESPONSE: "Full response received - R2 is triggered",
    REPEAT_STOP: "Max repeat count received - R4 is triggered",
    MOVE_ON_INTENT: "Intent received as move on - R7 is triggered",
    TIME_LIMIT_PROMPT: "Max prompt duration reached - R9 is triggered",
    TIME_LIMIT_PART: "Max part duration reached - R10 is triggered",
    SHORT_RESPONSE: "Max encrourage count received - R3 is triggered",
    NO_RESPONSE: "No response received - R1 is triggered",
    MOVE_TO_NEXT_PART: " Test is moved on as <20s left of parttime - R10 is triggered",
};

export const uploadFile = "preCheckLog";

export const colors = {
  hoelt:{primaryColor: '#0064AC'},
  ielts:{primaryColor: '#e31837'}
}


export const frameMappingData = () => {
    return [
        {
            key: "IntroFrame",
            value: "INTRO_FRAME",
        },
        {
            key: "frameA",
            value: "FRAME_A",
        },
        {
            key: "frameBCOne",
            value: "FRAME_B",
        },
        {
            key: "frameBCTwo",
            value: "FRAME_C",
        },
        {
            key: "part2Intro",
            value: "PART_2_INTRO_FRAME",
        },
        {
            key: "frameD",
            value: "FRAME_D",
        },
        {
            key: "part3Intro",
            value: "PART_3_INTRO_FRAME",
        },
        {
            key: "frameE",
            value: "FRAME_E",
        },
        {
            key: "frameF",
            value: "FRAME_F",
        },
        {
            key: "frameG",
            value: "FRAME_G",
        },
        {
            key: "frameH",
            value: "FRAME_H",
        },
        {
            key: "frameH",
            value: "FRAME_I",
        },
    ];
};